import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight, FaTruck, FaBuilding, FaBoxes } from 'react-icons/fa';
import {
  LOGISTICS_RFQ_FORM_OPTIONS,
} from '../../constants/logisticsRfqRoutes';
import '../../assets/styles/logistics_rfq_selection.scss';

const PRIMARY_OPTIONS = [
  {
    key: 'generic',
    title: 'Generic Logistics Services',
    description: LOGISTICS_RFQ_FORM_OPTIONS.generic.description,
    icon: <FaBoxes aria-hidden />,
    route: LOGISTICS_RFQ_FORM_OPTIONS.generic.route,
  },
  {
    key: 'specialized',
    title: 'Specialized Logistics Services',
    description: 'Business relocation, exhibition freight, and other tailored logistics programs.',
    icon: <FaTruck aria-hidden />,
    route: null,
  },
];

const SPECIALIZED_OPTIONS = [
  {
    key: 'business-relocation',
    title: 'Business Relocation',
    description: LOGISTICS_RFQ_FORM_OPTIONS.businessRelocation.description,
    icon: <FaBuilding aria-hidden />,
    route: LOGISTICS_RFQ_FORM_OPTIONS.businessRelocation.route,
  },
  {
    key: 'exhibition-logistics',
    title: 'Exhibition Logistics',
    description: LOGISTICS_RFQ_FORM_OPTIONS.exhibitionLogistics.description,
    icon: <FaTruck aria-hidden />,
    route: LOGISTICS_RFQ_FORM_OPTIONS.exhibitionLogistics.route,
  },
];

/**
 * Two-step RFQ type picker: Generic vs Specialized → relocation / exhibition.
 */
export default function LogisticsRfqTypeSelection({
  companyId = null,
  onNavigate,
  className = '',
  introText = 'Choose the type of logistics service that matches your requirement.',
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [step, setStep] = useState('primary');
  const [hoverKey, setHoverKey] = useState(null);

  const goToForm = (route) => {
    const params = new URLSearchParams(location.search);
    if (companyId != null && companyId !== '') {
      const n = Number(companyId);
      if (Number.isFinite(n) && n > 0) {
        params.set('companyId', String(n));
      }
    }
    const qs = params.toString();
    const path = qs ? `${route}?${qs}` : route;
    if (onNavigate) onNavigate(path);
    else navigate(path);
  };

  const options = step === 'primary' ? PRIMARY_OPTIONS : SPECIALIZED_OPTIONS;

  return (
    <div className={`logistics-rfq-selection ${className}`.trim()}>
      <p className="logistics-rfq-selection__intro text-secondary small mb-3">{introText}</p>

      {step === 'specialized' && (
        <button
          type="button"
          className="logistics-rfq-selection__back btn btn-link btn-sm px-0 mb-2"
          onClick={() => setStep('primary')}
        >
          <FaArrowLeft aria-hidden className="me-1" />
          Back to service type
        </button>
      )}

      {step === 'specialized' && (
        <h3 className="h6 fw-semibold mb-3">Specialized Logistics Services</h3>
      )}

      <div className="logistics-rfq-selection__grid">
        {options.map((opt) => (
          <button
            key={opt.key}
            type="button"
            className={`logistics-rfq-selection__card${
              hoverKey === opt.key ? ' logistics-rfq-selection__card--active' : ''
            }`}
            onMouseEnter={() => setHoverKey(opt.key)}
            onMouseLeave={() => setHoverKey(null)}
            onFocus={() => setHoverKey(opt.key)}
            onBlur={() => setHoverKey(null)}
            onClick={() => {
              if (opt.key === 'specialized') {
                setStep('specialized');
                setHoverKey(null);
                return;
              }
              if (opt.route) goToForm(opt.route);
            }}
          >
            <span className="logistics-rfq-selection__icon" aria-hidden>
              {opt.icon}
            </span>
            <span className="logistics-rfq-selection__title">{opt.title}</span>
            <span className="logistics-rfq-selection__desc">{opt.description}</span>
            <span className="logistics-rfq-selection__cta">
              Continue <FaArrowRight aria-hidden />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
